module.exports = __webpack_public_path__ + "img/Bananengeist.23073757.jpg";